import React from 'react'
import useLocale from '../../hooks/useLocale'
import { selectCurrencies } from '../../store/pricingSlice'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import Chevron from '../../../assets/media/select-arrow-black.svg?svgr-webpack'
import { CurrencyCodes } from 'js/locale'

function CurrencySwitcher() {
  const { currency, setCurrency } = useLocale()
  const currencies = useSelector(selectCurrencies)

  if (currencies.length < 2) return null

  return (
    <div className="c-currency-switcher" data-uid="currency-switcher">
      <label htmlFor="currency" className="c-currency-switcher__label">
        <FormattedMessage {...messages.currencyLabel} />: {currency}
      </label>
      <Chevron className="ml-4 opacity-75" width="6" />
      <select
        className="c-currency-switcher__select"
        id="currency"
        value={currency}
        onChange={(event) => setCurrency(event.target.value as CurrencyCodes)}
        data-uid="currency-switcher"
      >
        {[...currencies].sort().map((code) => (
          <option key={code} value={code}>
            {code}
          </option>
        ))}
      </select>
      <div className="c-currency-switcher__background" />
    </div>
  )
}

export default CurrencySwitcher
